import { AfterViewInit, Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ErrorList } from '../../shared-components/controls/error-prompt/error-list.model';
import { SharedService } from '../../shared-components/shared.service';
import { Enrollment } from '../../shared-components/student/enrollment.model';
import { Student } from '../../shared-components/student/student.model';
import { StudentService } from '../../shared-components/student/student.service';
import { System } from '../../shared-components/System';
import { GeneralPreferences } from '../../shared-components/user-preferences/general-preferences.model';
import { MassEmailPreferences } from '../../shared-components/user-preferences/mass-email-preferences.model';
import { UserPreferencesService } from '../../shared-components/user-preferences/user-preferences.service';
import { User } from '../../shared-components/user/user.model';
import { UserService } from '../../shared-components/user/user.service';
import { Year } from '../../shared-components/year/year.model';
import { YearService } from '../../shared-components/year/year.service';
import { LoginService } from '../login/login.service';
import { AddAttachmentsDialogComponent } from './add-attachments-dialog/add-attachments-dialog.component';
import { ChangeRecipientsDialogComponent } from './change-recipients-dialog/change-recipients-dialog.component';
import { EnrollmentWarningDialogComponent } from './enrollment-warning-dialog/enrollment-warning-dialog.component';
import { MailDetail } from './mail-detail';
import { MailParameters } from './mail-paremeters';
import { OptionNotAvailableDialogComponent } from './option-not-available-dialog/option-not-available-dialog.component';
import { Recipient } from './recipient.model';
import { SendEmailWarningDialogComponent } from './send-email-warning-dialog/send-email-warning-dialog.component';
import { SendEmailService } from './send-email.service';

@Component({
    selector: 'send-email',
    templateUrl: './send-email.component.html',
    styleUrls: [
        './send-email.component.css'
    ]
})
export class SendEmailComponent implements OnInit, AfterViewInit, OnDestroy {

    // Properties
    currentUser: User;
    teacherName: string;
    teacherEmailAddress: string;
    mailDetail = new MailDetail();
    subscriptions: Subscription[] = [];
    studentEnrollment: Enrollment;
    errors: ErrorList[] = [];
    recipients: Recipient[] = [];
    toSelections: number[] = [];
    CCSelections: number[] = [];
    BCCSelections: number[] = [];
    optionNotAvailable = false;
    viewOption = 3;
    createCommLogEntry = false;
    V10: boolean;
    yearSettings: any;
    selectedStudent: Student;
    @ViewChild('bodyContainer', { read: ElementRef }) bodyContainer: ElementRef;
    bodyHeight: number;
    emailChanged = false;
    emailAddress: string;
    selectedEmailName: string;
    staffUser = false;
    loginYear: Year;
    massEmailPreferences: MassEmailPreferences;
    modal = false;
    banner = '';
    maxTotalFileSize = 10485760;
    generalPreferences: GeneralPreferences;
    noReplyEmail = '';
    toSelected = false;
    footerWarning: string;
    sendEmailButtonLabel = 'Send';
    closeWithoutEmailButtonLabel = 'Close without Email';
    includeCloseWithoutEmailButton = false;

    additionalTo: string;
    additionalCc: string;
    additionalBcc: string;

    // Class Functions
    constructor(
        private sharedService: SharedService,
        private router: Router,
        private userService: UserService,
        private sendEmailService: SendEmailService,
        private studentService: StudentService,
        private dialog: MatDialog,
        private loginService: LoginService,
        private yearService: YearService,
        private userPreferencesService: UserPreferencesService,
        private dialogRef: MatDialogRef<SendEmailComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any
    ) { }

    // Event Functions
    ngOnInit() {
        // POST: initializes the data and shows initial warnings

        // Setting up local data
        this.currentUser = this.userService.currentUser;
        this.mailDetail.toMailId = this.teacherEmailAddress;
        this.mailDetail.toMailId = this.emailAddress;
        this.mailDetail.CCMailId = this.currentUser.Email;
        if (this.currentUser.UserType == 1) {
            this.mailDetail.CCDisplayMailId = this.currentUser.LastName + ', ' + this.currentUser.FirstName + ' <' + this.currentUser.Email + '>';
        } else {
            this.mailDetail.CCDisplayMailId = this.currentUser.LastName + ' ' + (this.currentUser.FirstName ? this.currentUser.FirstName.substring(0, 1) : '');
        }
        this.V10 = this.loginService.LoginSettings.V10;
        this.staffUser = this.userService.userType == 1;
        this.loginYear = this.yearService.loginYear;
        this.noReplyEmail = this.loginService.LoginSettings.DefaultEmailReplyToAddress;

        // Setting injected data
        if (this.data) {
            if (this.data.modal) {
                this.modal = this.data.modal;
            }
            if (this.data.banner) {
                this.banner = this.data.banner;
            }
            if (this.data.footerWarning) {
                this.footerWarning = this.data.footerWarning;
            }
            if (this.data.sendEmailButtonLabel) {
                this.sendEmailButtonLabel = this.data.sendEmailButtonLabel;
            }
            if (this.data.closeWithoutEmailButtonLabel) {
                this.closeWithoutEmailButtonLabel = this.data.closeWithoutEmailButtonLabel;
            }       
            this.includeCloseWithoutEmailButton = this.data.includeCloseWithoutEmailButton;                 
        }

        // Show option not available if the user doesn't have an email
        if (!this.currentUser.Email) {
            this.optionNotAvailable = true;
            this.dialog.open(OptionNotAvailableDialogComponent, {
                disableClose: true
            });
        }

        // Setting up subscriptions
        this.subscriptions.push(

            // Checking for recipient changes
            this.sendEmailService.observableRecipientsStream$.subscribe(recipients => {
                this.recipients = recipients;

                if (this.toSelections.length == 0 && (this.teacherName != null || this.teacherEmailAddress != null)) {
                    for (let i = 0; i < this.recipients.length; i++) {
                        if ((this.teacherName != null && this.recipients[i].Name.toLowerCase() === this.teacherName.toLowerCase()) ||
                            (this.teacherEmailAddress != null && this.recipients[i].Email.toLowerCase() === this.teacherEmailAddress.toLowerCase())) {
                            this.toSelections.push(this.recipients[i].Id);
                        }
                    }
                    this.mailDetail.toMailId = this.teacherEmailAddress;
                }
            }),

            // Checking for selected student change
            // Note, this is called immediately as this is a behavior subject
            this.studentService.selectedStudentStream$.subscribe(() => {

                // If there is a student, change recipient/sender
                if (this.studentService.selectedStudent || this.modal) {
                    this.mailDetail = new MailDetail();
                    this.teacherName = this.sendEmailService.teacherName;
                    this.teacherEmailAddress = this.sendEmailService.teacherEmailAddress;
                    
                    if (!this.modal) {
                        if (this.selectedStudent != null && this.selectedStudent.Id != this.studentService.selectedStudent.Id) {
                            this.toSelections.splice(0, this.toSelections.length);
                            this.CCSelections.splice(0, this.CCSelections.length);
                            this.BCCSelections.splice(0, this.BCCSelections.length);
                        }
                        this.selectedStudent = this.studentService.selectedStudent;
                        this.studentEnrollment = this.studentService.studentEnrollment;
                    }
                    this.mailDetail.CCMailId = (this.mailDetail.CCMailId == undefined) ? this.currentUser.Email : this.mailDetail.CCMailId;
                    if (this.currentUser.UserType == 1) {
                        this.mailDetail.CCDisplayMailId = this.currentUser.LastName + ', ' + this.currentUser.FirstName + ' <' + this.currentUser.Email + '>';
                    } else {
                        this.mailDetail.CCDisplayMailId = this.currentUser.LastName + ' ' + (this.currentUser.FirstName ? this.currentUser.FirstName.substring(0, 1) : '');
                    }
                    if (this.V10 && this.CCSelections.filter(s => s == this.currentUser.MemberId).length == 0) {
                        this.CCSelections.push(this.currentUser.MemberId);
                    }
                    else if (!this.V10 && this.CCSelections.filter(s => s == this.currentUser.Id).length == 0) {
                        this.CCSelections.push(this.currentUser.Id);
                    }
                    this.sendEmailService.recipients = [];
                    if (this.studentEnrollment || this.modal) {
                        if (!this.optionNotAvailable && !this.teacherEmailAddress && (!this.emailAddress || this.emailAddress.length < 1)) {
                            this.changeRecipients();
                        }
                    } else {
                        this.dialog.open(EnrollmentWarningDialogComponent, {
                            disableClose: true
                        });
                    }
                }
                // If there is no student, return to summary
                else {
                    this.emailChanged = false;
                    if (this.userService.userType == 1) {
                        this.router.navigateByUrl('classroom360/cards');
                    } else {
                        this.router.navigateByUrl('student360/studentSummary');
                    }
                }
            })
        );        

        // Setting injected data after mailDetail is initialized
        if (this.data && this.mailDetail) {
            if (this.data.subject) {
                this.mailDetail.subject = this.data.subject;
            }
            if (this.data.message) {
                this.mailDetail.message = this.data.message;
            }
        }

        // If this is a teacher and we're not in V10, check the year settings
        if (this.currentUser.UserType == 1 && !this.V10) {
            this.subscriptions.push(
                this.yearService.getSchoolYearSettings(
                    this.yearService.loginYear.Id,
                    this.yearService.loginYear.SchoolID
                ).subscribe(yearSettings => {
                    this.yearSettings = yearSettings;
                    this.createCommLogEntry = !this.modal ? this.yearSettings.AutoAddEmail : false;
                })
            );
        }

        // Applying the signature
        if (this.userService.userType == 1) {
            this.getPreferences();
        }
    }

    @HostListener('window:resize')
    ngAfterViewInit() {
        // POST: sets the initial height to the body
        // NOTE: the -50 has to do with Angular padding and margins
        setTimeout(() => {
            if (this.bodyContainer) {
                this.bodyHeight = this.bodyContainer.nativeElement.offsetHeight - 50;
            }
        }, 0);
    }

    ngOnDestroy() {
        // POST: ends all subscriptions
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }

    send() {
        // PRE: the send button is clicked
        // POST: sends the email

        // Checking for errors
        this.validate();
        if (this.errors.length == 0) {

            // Checking for warnings
            if (!this.mailDetail.subject || !this.mailDetail.message) {
                const dialogBox = this.dialog.open(SendEmailWarningDialogComponent, {
                    data: {
                        noSubject: !this.mailDetail.subject,
                        noContent: !this.mailDetail.message
                    },
                    disableClose: true
                });
                this.subscriptions.push(
                    dialogBox.afterClosed().subscribe(sendAnyway => {
                        if (sendAnyway) {
                            this.sendMail();
                        }
                    })
                );
            }

            // Sending mail
            else {
                this.sendMail();
            }
        }
    }

    closeClick() {
        this.dialogRef.close('Cancel was clicked.');
    }

    closeWithoutEmailClick() {
        this.dialogRef.close('Close without email was clicked.');
    }

    cancel() {
        // PRE: the cancel button is clicked
        // POST: navigates to the previous URL
        // NOTE: this was depreciated since this was made a page. It might be changed to a modal in the future.
        this.router.navigateByUrl(this.sharedService.previousUrl);
    }

    // Methods
    getPreferences() {
        // POST: obtains the preferences, specifically for the signature
        this.subscriptions.push(
            this.userPreferencesService.getUserPreferences(0, '/OneSISMassEmail').subscribe(results => {
                this.userPreferencesService.massEmailPreferences = JSON.parse(results[0]);
                this.massEmailPreferences = JSON.parse(JSON.stringify(this.userPreferencesService.massEmailPreferences));
                if (this.massEmailPreferences.Signature != '' && this.mailDetail.message == '') {
                    this.mailDetail.message = this.mailDetail.message + '<p><br /><br /><br /></p>' + this.massEmailPreferences.Signature;
                }
            }),
            this.userPreferencesService.getGeneralPreferences().subscribe(result => {
                this.generalPreferences = result;
            })
        );
    }

    changeRecipients() {
        // POST: opens the change recipients dialog
        if (this.studentEnrollment) {
            const dialogIndex = this.dialog.openDialogs.findIndex(dialog => dialog.componentInstance instanceof ChangeRecipientsDialogComponent);
            if (dialogIndex == -1) {
                const dialogBox = this.dialog.open(ChangeRecipientsDialogComponent, {
                    data: {
                        viewOption: this.viewOption,
                        mailDetail: this.mailDetail,
                        toSelections: this.toSelections,
                        CCSelections: this.CCSelections,
                        BCCSelections: this.BCCSelections,
                        teacherEmailAddress: this.teacherEmailAddress,
                        userEmailAddress: this.currentUser.Email,
                        additionalTo: this.additionalTo,
                        additionalCc: this.additionalCc,
                        additionalBcc: this.additionalBcc,
                    },
                    disableClose: true
                });
                this.subscriptions.push(
                    dialogBox.afterClosed().subscribe(changed => {
                        this.additionalTo =  dialogBox.componentInstance.additionalTo;
                        this.additionalCc =  dialogBox.componentInstance.additionalCc;
                        this.additionalBcc =  dialogBox.componentInstance.additionalBcc;
                        this.viewOption = dialogBox.componentInstance.viewOption;
                        if (changed) {
                            this.toSelected = dialogBox.componentInstance.toSelected;
                            this.emailChanged = changed;
                        }
                    })
                );
            }
        } else {
            this.dialog.open(EnrollmentWarningDialogComponent);
        }
    }

    addAttachment() {
        // POST: shows the add attachments dialog
        const dialogBox = this.dialog.open(AddAttachmentsDialogComponent, {
            data: {
                attachments: this.mailDetail.attachments
            },
            disableClose: true
        });
        this.subscriptions.push(
            dialogBox.afterClosed().subscribe(changed => {
                if (changed) {
                    this.emailChanged = changed;
                }
            })
        );
    }

    validate() {
        // POST: sets the errors
        this.errors = [];

        const mailFormat = System.mailRegexp;

        // The email must have something for content
        let attachments = false;
        for (let i = 0; i < this.mailDetail.attachments.length; i++) {
            if (this.mailDetail.attachments[i].Base64String) {
                attachments = true;
                break;
            }
        }
        if (attachments) {
            let attachmentSize = 0;
            for (let j = 0; j < this.mailDetail.attachments.length; j++) {
                if (this.mailDetail.attachments[j].Base64String != undefined && this.mailDetail.attachments[j].Base64String != null && this.mailDetail.attachments[j].Base64String != '') {
                    attachmentSize = attachmentSize + (window.atob(this.mailDetail.attachments[j].Base64String).length / (1024 * 1024));
                }
            }
            if (attachmentSize > 10) {
                this.errors.push({
                    fieldRef: null,
                    fieldName: '',
                    errorMsg: 'The total size of the files you have attached exceeds the 10 MB limit.'
                });
            }
        }

        if (!this.mailDetail.subject && !this.mailDetail.message && !attachments) {
            this.errors.push({
                fieldRef: null,
                fieldName: '',
                errorMsg: 'Email has no content, subject, or attachment.'
            });
        }

        if (this.modal && this.mailDetail.CCMailId) {
            let validEmails = true;

            if (!this.mailDetail.CCMailId.match(mailFormat)) {
                const splitEmails: string[] = this.mailDetail.CCMailId.split(';');
                splitEmails.forEach(email => {
                    if (!email.match(mailFormat) && email != '') {
                        validEmails = false;
                    }
                });
            }

            if (!validEmails) {
                this.errors.push({
                    fieldRef: null,
                    fieldName: '',
                    errorMsg: 'Invalid email address(es) in the CC field'
                });
            }

        }

    }

    sendMail() {
        // POST: sends the email

        // Removed for ONE-10154 as it was replacing spaces with % on the Mass Email Log page
        // // Determining the subject
        // const subject = encodeURIComponent(this.mailDetail.subject).replace(/[!'()]/g, escape).replace(/\*/g, '%2A');

        // Organizing the parameters
        const params = new MailParameters();
        params.userId = this.currentUser.Id;
        params.EmailFrom = this.generalPreferences && this.generalPreferences.EmailFrom.toLowerCase() == 'no reply' ? this.noReplyEmail : this.currentUser.Email;
        params.EmailTo = this.mailDetail.toMailId;
        params.DisplayEmailToOnComment = 'To: ' + this.mailDetail.toSelectedMailId;
        if (this.modal) {
            params.DisplayEmailCcOnComment = 'CC: ' + this.mailDetail.CCMailId;
        }
        else if (this.mailDetail.CCSelectedMailId && this.mailDetail.CCSelectedMailId.length > 0) {
            params.DisplayEmailCcOnComment = 'CC: ' + this.mailDetail.CCSelectedMailId;
        } else if (this.currentUser.Email) {
            params.DisplayEmailCcOnComment = 'CC: ' + this.currentUser.FirstName + ' ' + this.currentUser.LastName + '<' + this.currentUser.Email + '> ';
        }
        else {
            params.DisplayEmailBccOnComment = 'BCC: ' + this.mailDetail.BCCSelectedMailId;
        }
        if (this.mailDetail.BCCSelectedMailId && this.mailDetail.BCCSelectedMailId.length > 0) {
            params.DisplayEmailBccOnComment = 'BCC: ' + this.mailDetail.BCCSelectedMailId;
        }
        params.EmailToCc = this.mailDetail.CCMailId;
        params.EmailToBcc = this.mailDetail.BCCMailId;
        params.Subject = this.mailDetail.subject;
        params.Body = this.mailDetail.message;
        params.HtmlBody = true;
        params.AddEmailToParentContactLog = this.createCommLogEntry;
        params.PeopleIds = this.mailDetail.peopleIds;
        if (this.V10) {
            params.ToMemIds = this.toSelections;
            params.CCMemIds = this.CCSelections;
            params.BCCMemIds = this.BCCSelections;
        }
        if (this.mailDetail.personCodeMother > 0) {
            params.PersonCode = this.mailDetail.personCodeMother;
        } else {
            params.PersonCode = this.mailDetail.personCodeFather;
        }

        // Adding the attachments
        params.Attachments = [];
        this.mailDetail.attachments.forEach(attachment => {
            if (attachment.Base64String) {
                params.Attachments.push(attachment);
            }
        });

        // Sending the email
        this.subscriptions.push(
            this.sendEmailService.sendEmail(params, 'Single Student', this.modal).subscribe(
                (result) => {
                    if (result) {
                        this.sharedService.showGoodSnackbar('Email sent');
                        this.emailChanged = false;
                        if (this.sharedService.previousUrl && !this.userService.studentInformationView) {
                            this.router.navigateByUrl(this.sharedService.previousUrl);
                        }
                        if (this.modal || this.userService.studentInformationView == true) {
                            this.dialogRef.close('Email sent.');
                        }
                    } else {
                        this.sharedService.showBadSnackbar('Email failed to send');
                    }
                },
                () => {
                    this.sharedService.showBadSnackbar('Email failed to send');
                }
            )
        );
    }

    viewFile = (base64: string, fileType: string, fileName: string) => {
        System.viewFileFromBase(base64, fileType, fileName);
    }
}
